import { Injectable } from "@angular/core";
import {
  ProductClient,
  ProductUpSaleViewModel,
  ProductViewModel,
  ProductViewModelBase,
} from "src/domain/client";
import { ChannelRequestService } from "./channel-request.service";
import { ErrorReporterService } from "./error-reporter.service";

@Injectable({
  providedIn: "root",
})
export class ProductService {
  constructor(
    private errorReporter: ErrorReporterService,
    private channelRequestService: ChannelRequestService,
  ) {}

  getProduct(SKU: string): Promise<ProductViewModel> {
    if (!this.channelRequestService.channelRequest?.channelRequestId) {
      return Promise.reject(new Error("No channelRequestId specified"));
    }
    return new ProductClient().details(
      SKU,
      this.channelRequestService.channelRequest.channelRequestId,
    );
  }

  getProducts(ids: number[]): Promise<ProductViewModelBase[]> {
    if (!this.channelRequestService.channelRequest?.channelRequestId) {
      return Promise.reject(new Error("No channelRequestId specified"));
    }
    return new ProductClient()
      .base(this.channelRequestService.channelRequest.channelRequestId, ids)
      .catch((err) => {
        this.errorReporter.handle(err);
        return Promise.reject(err);
      });
  }

  getPopularProducts(categoryId?: number): Promise<ProductViewModelBase[]> {
    if (!this.channelRequestService.channelRequest?.channelRequestId) {
      return Promise.reject(new Error("No channelRequestId specified"));
    }
    return new ProductClient().popular(
      this.channelRequestService.channelRequest.channelRequestId,
      categoryId,
    );
  }

  getProductUpSales(sku: string): Promise<ProductUpSaleViewModel[]> {
    if (!this.channelRequestService.channelRequest?.channelRequestId) {
      return Promise.reject(new Error("No channelRequestId specified"));
    }
    return new ProductClient().upSales(
      sku,
      this.channelRequestService.channelRequest.channelRequestId,
    );
  }
}
